<div class="modal fade" tabindex="-1" [id]="'corridorModal'">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <img [src]="img!" class="modal-logo" alt="corridor logo">
            </div>
            <form [formGroup]="settingsHallwayHeight">
                <div class="modal-body text-center">
                    <ul id="corridor-calculate-container">
                        <li>
                            <div>{{ "SETTING.MIMESYS.ERGOCORRIDOR.REFERENCE" |translate}}</div>
                            <div>{{gazeMap.referencia}}</div>
                        </li>
                        <li>
                            <div>Test ID</div>
                            <div>{{gazeMap.testId}}</div>
                        </li>
                        <li>
                            {{ "SETTING.MIMESYS.ERGOCORRIDOR.LABEL4" |translate}}
                        </li>

                        <li>
                            <div>{{ "SETTING.MIMESYS.ERGOCORRIDOR.VERTEXDISTANCE" |translate}}</div>
                            <div>
                                <input class="form-text-input" type="number" [id]="'vertexDistance'"
                                    formControlName="vertexDistance" step="0.1">
                                <hbo-field-validation fieldName="vertexDistance"></hbo-field-validation>
                            </div>
                        </li>
                        <li>
                            <div>{{ "SETTING.MIMESYS.ERGOCORRIDOR.PANTOSCIPICANGLE" |translate}}</div>
                            <div>
                                <input class="form-text-input" type="number" [id]="'pantoscipicAngle'"
                                    formControlName="pantoscipicAngle" step="0.1">
                                <hbo-field-validation fieldName="pantoscipicAngle"></hbo-field-validation>
                            </div>
                        </li>

                    </ul>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-dark" (click)="calculate()" 
                    [ngClass]="{'calculate-disabled':!settingsHallwayHeight.valid}">{{
                        'COMMON.CALCULATE' | translate }}</button>
                </div>
                <div class="modal-body text-center">
                    <ul *ngIf="!action.refresh" id="corridor-calculation-container">
                        <li>
                            <div>{{ "SETTING.MIMESYS.ERGOCORRIDOR.HALLWAYHEIGHT" |translate}}</div>
                            <div>
                                <input class="form-text-input" type="number" [id]="'hallwayHeight'"
                                    formControlName="hallwayHeight" lang="nl" readonly>
                            </div>
                        </li>
                    </ul>
                </div>
            </form>
        </div>
    </div>
</div>